import { Section, Heading, Cta } from './home-ui';

export default function ClosingCta({ data }) {
    if (!data) return null;
    const { titleLine1, titleLine2, paragraph, primaryCta, secondaryCta } = data;

    return (
        <Section bg="navy" className="text-center">
            <div className="mx-auto max-w-3xl">
                <Heading line1={titleLine1} line2={titleLine2} onNavy className="!text-[34px] sm:!text-[46px]" />
                {paragraph && <p className="mx-auto mt-5 max-w-2xl text-lg text-white/75">{paragraph}</p>}
                <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                    {primaryCta && <Cta label={primaryCta.label} href={primaryCta.href} onNavy />}
                    {secondaryCta && <Cta label={secondaryCta.label} href={secondaryCta.href} variant="outline" onNavy />}
                </div>
            </div>
        </Section>
    );
}
